import { useState, useEffect, useRef } from 'react';
import { FreestarAd } from '../Freestar/FreestarAd';
import styled from 'styled-components'

function VerticalAd() {
	const defaultADTop = 120
	const heightOfTop = 120;
	const [fixed, setFixed] = useState(false);
	const [adDivHeight, setAdDivHeight] = useState(0);
	const [adTop, setAdTop] = useState(defaultADTop);

	// https://www.geeksforgeeks.org/how-to-determine-the-size-of-a-component-in-reactjs/
	const refCont = useRef<HTMLDivElement>(null);
	useEffect(() => {
		if (refCont.current && adDivHeight === 0) {
			setAdDivHeight(refCont.current.offsetHeight);
		}
	}, []);

	const setFixedSidebar = () => {
		if (window.scrollY >= heightOfTop) {
			setFixed(true);
			if (refCont.current && window.scrollY >= refCont.current.offsetHeight - 500) {
				setAdTop(refCont.current.scrollTop + 30);
			} else {
				setAdTop(defaultADTop);
			}
		} else {
			setFixed(false);
			setAdTop(defaultADTop);
		}
	}

	window.addEventListener('scroll', setFixedSidebar)

	return (
		<VertAd id='vertad' ref={refCont}>
			<AdDiv top={adTop} fixed={fixed}>
				<FreestarAd placementName={'titantv_right_rail'}></FreestarAd>
			</AdDiv>
		</VertAd>
	)
}

interface AdProps {
	top: number;
	fixed: boolean
}

const AdDiv = styled.div<AdProps>`
	position: ${props => props.fixed ? 'fixed' : 'sticky'};
	width: 150px;
	height: 600px;
	top: ${props => props.top}px;
	margin: 5px;
	//background: red;

	@media print {
		display: none
	}
`;

const VertAd = styled.div`
	//background: lightgray;
	margin: 10px 0 10px 10px;
	min-width: 170px;
	max-width: 170px;

	@media (max-width: 705px) {
		display: none;
	}

	@media print {
		display: none
	}
`

export default VerticalAd